// extracted by mini-css-extract-plugin
export default {"payment":"styles_payment__tJ+B6","note":"styles_note__dUkHu"};